<template>
  <div class="shipping-checkpoint-form" v-if="shippingEdit">
    <b-form @submit.stop.prevent="editCheckpoint">
      <b-row>
        <b-col>
          <create-checkpoint-address-form :shipping="shippingEdit" :checkpoint="checkpoint" meta-type="meta" />
        </b-col>
      </b-row>
      <b-row>
        <b-form-group class="col-12">
          <label for="contact" v-translate>Contact Name</label>
          <b-form-input id="contact" v-model="shippingEdit[checkpoint + '_contact']" required />
        </b-form-group>
        <b-form-group class="col-6">
          <label for="email" v-translate>Contact E-mail</label>
          <b-form-input id="email" v-model="shippingEdit[checkpoint + '_email']" />
        </b-form-group>
        <b-form-group class="col-6">
          <label for="phone" v-translate>Contact Phone</label>
          <input-phone id="phone" :phone-number="shippingEdit[checkpoint + '_phone']" @update="setPhone" :default-country-code="defaultCountryCode" />
        </b-form-group>
        <b-form-group class="col-6">
          <label for="meta">
            <translate>Special instructions</translate>
            <em class="text-info"><small v-translate>(up to 2048 characters)</small></em>
          </label>
          <b-form-textarea id="meta" v-model="shippingEdit[checkpoint + '_meta']" :rows="3" :max-rows="6" @update="countdown(checkpoint + '_meta', 2048)" :state="invalid[checkpoint + '_meta']" />
          <p class="text-right mb-0" v-bind:class="{'text-danger': invalid[checkpoint + '_meta'] === false }"><small>{{limits[checkpoint + '_meta']}}</small></p>
          <small class="form-text text-muted"><translate>Is there any special instruction for our Courier at this checkpoint?</translate><br>
          <translate>i.e.</translate> <em v-translate>The door bell is not working</em></small>
        </b-form-group>
      </b-row>
      <b-row>
        <b-form-group class="col-12 form-actions">
          <b-button type="submit" variant="secondary" size="md" v-translate>Update Information</b-button>
          <b-button type="button" @click="emitCancel" variant="outline-secondary" size="md" v-translate>Cancel</b-button>
        </b-form-group>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import {
  ShippingService
} from '@/services/api'
import _ from 'lodash'
import InputPhone from '@/components/InputPhone'
import ShippingCheckpointFormAddress from '@/components/Shippings/CheckpointFormAddress'
import CreateCheckpointAddressForm from '@/components/Shippings/CreateCheckpointAddressForm'

export default {
  name: 'ShippingCheckpointForm',
  components: {
    InputPhone,
    ShippingCheckpointFormAddress,
    CreateCheckpointAddressForm
  },
  props: {
    shipping: {
      type: Object,
      default: () => {},
      required: true
    },
    checkpoint: {
      type: String,
      default: 'to'
    },
    newAddress: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      shippingEdit: {},
      invalid: {},
      limits: {}
    }
  },
  computed: {
    moovaCountries() {
      return window.countries.map(x => x.iso_code)
    },
    defaultCountryCode() {
      return this.shipping.to_country_iso_code || (this.shipping.company ? this.shipping.company.country_iso_code : 'AR')
    }
  },
  mounted() {
    this.shippingEdit = JSON.parse(JSON.stringify(this.shipping))
    this.countdown(this.checkpoint + '_meta', 2048)
    this.shippingEdit[this.checkpoint + '_phone'] = this.shippingEdit[this.checkpoint + '_phone'] || ' '
  },
  methods: {
    setPlace($e) {
      console.log($e)
      this.shippingEdit = {...this.shippingEdit, ...$e} // Object.assign({}, this.shippingEdit, $e)
    },
    editCheckpoint() {
      if (!this.newAddress) {
        let updatedKeys = _.reduce(this.shippingEdit, function (result, value, key) {
          return _.isEqual(value, this.shipping[key])
            ? result
            : result.concat(key)
        }.bind(this), [])

        let payload = {}
        for (const key of updatedKeys) {
          if (key !== 'meta') {
            payload[key] = this.shippingEdit[key] || null
          } else {
            payload[key] = {...this.shipping[key], ...this.shippingEdit[key]}
          }
        }
        let fieldsToUpdate = payload
        if (this.shippingEdit.force_place_id) {
          delete fieldsToUpdate.force_place_id
          fieldsToUpdate = {...fieldsToUpdate, ...{[this.checkpoint + '_place_id']: this.shippingEdit[this.checkpoint + '_place_id']}}
        }
        ShippingService.update(this.shipping.id, fieldsToUpdate)
          .then(() => {
            this.emitSuccess()
          })
      } else {
        this.emitSuccess()
      }
    },
    setPhone($e) {
      this.shippingEdit[this.checkpoint + '_phone'] = $e
    },
    countdown(value, limit) {
      this.limits[value] = this.shippingEdit[value] ? limit - this.shippingEdit[value].length : null
      this.invalid[value] = this.shippingEdit[value] ? this.shippingEdit[value].length <= limit : null
    },
    emitSuccess() {
      this.$emit('success', this.shippingEdit)
    },
    emitCancel() {
      this.$emit('cancel', true)
    }
  }
}
</script>
